export default __webpack_public_path__ + "static/media/01final.31bd5ff2.png";